module.exports = "<a :href=\"link\" class=\"card\">\n\t<div class=\"card__inner\">\n\t\t<div\n\t\t\tclass=\"card__img\">\n\t\t\t<div class=\"card__img-inner\" :style=\"{backgroundImage: 'url('+img+')'}\"></div>\n\t\t</div>\n\t\t<div :class=\"['card__heading-wrapper', {'card__heading-wrapper--move-up': img}]\">\n\t\t\t<h2\n\t\t\t\tclass=\"card__heading\"\n\t\t\t\tv-html=\"title\"></h2>\n\t\t</div>\n\t\t<p\n\t\t\tclass=\"card__desc\"\n\t\t\tv-html=\"desc\"></p>\n\t</div>\n</a>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/card/card.vhtml
// module id = 239
// module chunks = 0